import React from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';

import EarthIcon from 'assets/map_toggle/earth.svg';
import ListIcon  from 'assets/map_toggle/list.svg';

import './i18n';
import styles from './styles.module.scss';

interface Props {
  /** Where the button goes: the map of the list, or the list of the map (with the filters in the query). */
  listPath: string;
  /** `true` on a map screen ("Ver lista"), `false` on a list ("Ver mapa"). */
  defaultChecked?: boolean;
  className?: string;
}

/** Green button that switches between a list and its map. */
function MapToggle({ listPath, defaultChecked = true, className }: Props) {
  const isMapView = defaultChecked;

  return (
    <div className={className}>
      <Link to={listPath} className={styles.toggleButton}>
        <img src={isMapView ? ListIcon : EarthIcon} className={styles.icon} alt="" />
        <span className={styles.label}>{i18next.t(isMapView ? 'mapToggle:showList' : 'mapToggle:showMap')}</span>
      </Link>
    </div>
  );
}

export default MapToggle;
